import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import Modal from "react-bootstrap/Modal";
import { createProjectMaintenance } from "../../helpers/axios/maintenanceAxios";
import {
  agGridOptionsNone,
  agGridTheme,
} from "../../helpers/constants/Constants";

const MaintenanceSidePanel = () => {
  const { superUserDetails, selectedProject } = useSelector(
    (state) => state.globalReducer
  );
  const { selectedObjectData } = useSelector((state) => state.modelReducer);
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [showRecordModal, setShowRecordModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [recordInput, setRecordInput] = useState({
    createdByEmail: superUserDetails?.email,
    projectId: selectedProject[0]?.mviewProjectInfo?.id,
  });

  useEffect(() => {
    // Spread both pending and complete checklist into gridData
    if (selectedObjectData) {
      let tempData = [];
      if (selectedObjectData) {
        selectedObjectData.maintenance?.forEach((maintenance) => {
          tempData.push({
            ...maintenance,
          });
        });
        setGridData(tempData);
      }
    }
  }, [selectedObjectData]);

  const idCellRenderer = (params) => {
    return (
      <button
        className="btn btn-primary btn-sm"
        onClick={() => {
          setRecordInput({
            ...recordInput,
            projectObjectId: selectedObjectData.projectObjectId,
            staticObjectMaintenanceId: params.data.staticObjectMaintenanceId,
            dimension: params.data.dimension,
            interval: params.data.interval,
            intervalHours: params.data.intervalHours,
            description: params.data.description,
            lastPerformed: params.data.lastPerformed,
            nextDue: params.data.nextDue,
          });
          setSelectedRow([params.data]);
          setShowRecordModal(true);
        }}
      >
        View
      </button>
    );
  };

  const columnDefs = [
    {
      headerName: "View",
      field: "view",
      cellRenderer: idCellRenderer,
      width: 90,
      suppressMenu: true,
      sortable: false,
      filter: false,
    },
    {
      headerName: "Interval",
      field: "interval",
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        if (!params.data.dimension) return params.data.interval;
        const units = { D: "Day(s)", M: "Month(s)", Y: "Year(s)" };
        const unit = units[params.data.dimension] || "";
        const interval = `${params.data.interval} ${unit}`;
        return (
          interval +
          (params.data.intervalHours
            ? ` or ${Number(
                params.data.intervalHours
              ).toLocaleString()} Hour(s)`
            : "")
        );
      },
    },
    {
      headerName: "Description",
      field: "description",
      sortable: true,
      filter: true,
      autoHeight: true,
      cellStyle: { whiteSpace: "normal", lineHeight: "1.5" },
    },
    {
      headerName: "Last Performed",
      field: "lastPerformed",
      sortable: true,
      filter: true,
      //dynamically change the colour of the cell based on the date
      valueFormatter: (params) => {
        if (!params.value) return "N/A"; // Handle cases where nextDue is null or undefined
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      },
    },
    {
      headerName: "Next Due",
      field: "nextDue",
      sortable: true,
      filter: true,
      //if the nextDue date is in the past, change the colour of the cell to red using bg-danger
      cellClass: (params) => {
        return params.value && new Date(params.value) > new Date()
          ? ""
          : "bg-danger";
      },
      valueFormatter: (params) => {
        if (!params.value) return "N/A"; // Handle cases where nextDue is null or undefined
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      },
    },
  ];
  const onGridReady = (params) => {
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.sizeColumnsToFit();
    }
  }, [gridData, gridApi]);

  return (
    <div>
      <Modal
        show={showRecordModal}
        onHide={(e) => {
          setShowRecordModal(false);
        }}
      >
        <Modal.Header
          closeButton={(e) => {
            setShowRecordModal(false);
          }}
        >
          <Modal.Title>Confirm Add</Modal.Title>
          <div
            data-bs-theme="dark"
            style={{
              position: "absolute",
              right: 20,
            }}
          >
            <button
              type="button"
              className="btn-close"
              onClick={(e) => {
                setShowRecordModal(false);
              }}
              aria-label="Close"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          {/* Recieve the input from the user for the modal name and keys */}
          {selectedRow && selectedRow.length > 0 && (
            <div>
              <h5>Maintenance Details</h5>
              <div className="mb-3">
                <strong>MUID:</strong> {selectedRow[0].muid}
                <br />
                <strong>Interval:</strong> {selectedRow[0].interval}{" "}
                {selectedRow[0].dimension
                  ? { D: "Day(s)", M: "Month(s)", Y: "Year(s)" }[
                      selectedRow[0].dimension
                    ] || ""
                  : ""}
                {selectedRow[0].intervalHours
                  ? ` or ${Number(
                      selectedRow[0].intervalHours
                    ).toLocaleString()} Hour(s)`
                  : ""}
                <br />
                <strong>Description:</strong> {selectedRow[0].description}
                <br />
                <strong>Last Performed:</strong>{" "}
                {selectedRow[0].lastPerformed
                  ? new Date(selectedRow[0].lastPerformed).toLocaleDateString(
                      "en-GB"
                    )
                  : "N/A"}
                <br />
                <strong>Next Due:</strong>{" "}
                {selectedRow[0].nextDue
                  ? new Date(selectedRow[0].nextDue).toLocaleDateString("en-GB")
                  : "N/A"}
                <br />
              </div>
              <h6>History</h6>
              <div
                style={{
                  maxHeight: 200,
                  overflowY: "auto",
                  border: "1px solid #eee",
                  borderRadius: 4,
                  padding: 8,
                  marginBottom: 16,
                }}
              >
                {Array.isArray(selectedRow[0].history) &&
                selectedRow[0].history.length > 0 ? (
                  selectedRow[0].history.map((rec, idx) => (
                    <div
                      key={idx}
                      style={{
                        borderBottom: "1px solid #ddd",
                        marginBottom: 8,
                        paddingBottom: 8,
                      }}
                    >
                      <div>
                        <strong>Date:</strong>{" "}
                        {rec.createdDate
                          ? new Date(rec.createdDate).toLocaleDateString(
                              "en-GB"
                            )
                          : "N/A"}
                      </div>
                      <div>
                        <strong>Performed By:</strong>{" "}
                        {rec.createdByEmail || "N/A"}
                      </div>
                      <div>
                        <strong>Action:</strong> {rec.action || "N/A"}
                      </div>
                      {rec.hours && (
                        <div>
                          <strong>Hours:</strong> {rec.hours}
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div>No history records found.</div>
                )}
              </div>
              <h6>Record New Maintenance</h6>
              <div className="mb-2">
                <label className="form-label">
                  Description of Actions Carried Out
                </label>
                <textarea
                  className="form-control"
                  rows={3}
                  value={recordInput.action || ""}
                  onChange={(e) =>
                    setRecordInput({ ...recordInput, action: e.target.value })
                  }
                  placeholder="Describe the actions carried out"
                />
              </div>
              {selectedRow[0].intervalHours && (
                <div className="mb-2">
                  <label className="form-label">Number of Hours</label>
                  <input
                    type="number"
                    className="form-control"
                    value={recordInput.hours || ""}
                    min={0}
                    onChange={(e) =>
                      setRecordInput({ ...recordInput, hours: e.target.value })
                    }
                    placeholder="Enter number of hours"
                  />
                </div>
              )}
            </div>
          )}
          <div className="d-flex justify-content-end p-1">
            <button
              className="btn btn-secondary btn-sm"
              onClick={(e) => {
                setShowRecordModal(false);
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-success btn-sm"
              onClick={(e) => {
                createProjectMaintenance(recordInput)
                  .then((maintenance) => {
                    //update the selected object data with the new maintenance record
                    const updatedMaintenanceData = gridData.map((item) => {
                      if (item.muid === selectedRow[0].muid) {
                        return {
                          ...item,
                          lastPerformed: maintenance.createdDate,
                          nextDue: new Date(
                            maintenance.createdDate
                          ).toLocaleDateString("en-GB"),
                          history: [
                            ...(Array.isArray(item.history)
                              ? item.history
                              : []),
                            {
                              createdDate: maintenance.createdDate,
                              createdByEmail: maintenance.createdByEmail,
                              action: recordInput.action,
                              hours: recordInput.hours,
                            },
                          ],
                        };
                      }
                      return item;
                    });
                    setGridData(updatedMaintenanceData);
                    setShowRecordModal(false);
                  })
                  .catch(console.log);
              }}
            >
              Record
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <div style={{ height: 400, width: "100%" }}>
        <AgGridReact
          theme={agGridTheme}
          rowData={gridData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridOptions={{
            ...agGridOptionsNone,
            getRowClass: (params) => {
              return params.data.nextDue &&
                new Date(params.data.nextDue) > new Date()
                ? ""
                : "bg-danger";
            },
          }}
        />
      </div>
    </div>
  );
};

export default MaintenanceSidePanel;
